export const DEFAULT_FONT_FAMILY = 'Mulish';
